function tabs() {
  // Tabs functionality
  const tabsTab = document.querySelectorAll('.tabs__tab');
  const tabsPane = document.querySelectorAll('.tabs__pane');
  const tabsNav = document.querySelector('.tabs__nav');
  const tabsButton = document.querySelector('.tabs__button');
  
  if (typeof tabs !== 'undefined' && tabs !== null) {
    for (let index = 0; index < tabsTab.length; index++) {
      tabsTab[index].addEventListener('click', function () {
        tabsTab.forEach((element) => {
          // Remove active class from all tabs
          element.classList.remove('tabs__tab--active');
          // Set aria false
          element.setAttribute('aria-selected', 'false');
        });

        tabsPane.forEach((element) => {
          // Remove active class from all panes
          element.classList.remove('tabs__pane--active');
        });

        // Add active class to just selected tab
        this.classList.toggle('tabs__tab--active');
        // Add aria attr to just selected tab
        this.setAttribute('aria-selected', 'true');
        // Add active class to pane
        tabsPane[index].classList.add('tabs__pane--active');
      });
    }

    if (tabsButton) {
      // Clicking on tabs button shows tabs nav
      tabsButton.addEventListener('click', function() {
        tabsNav.classList.toggle('tabs__nav--visible');
        this.classList.toggle('tabs__button--active');

        if (this.classList.contains('tabs__button--active')) {
          this.setAttribute('aria-label', 'Hide Categories');
        } else {
          this.setAttribute('aria-label', 'Show Categories');
        }
      });
    }
  }
}

export default tabs;
